const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const GiftCardQuery = {
    GetGiftCardTransactionReport: Backofficebff + '/v1/GiftCard/get-gift-card-transaction-report'
};
